import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    checks: {
      company: 'The mandate must mention your client’ company.',
      contractor:
        'The mandate must designate your client as the **contractor**.',
      date: 'The mandate must be **less than 3 months old**.',
      mandatee:
        'The mandate must designate you or your company as the **mandatee**.',
      power:
        'The mandate **must** stipulate that you have the power to **initiate the capital deposit** and **open a bank account**.',
      signature: 'The mandate must be signed **by your client**.',
    },
    template: 'Download our mandate template',
    upload: {
      description: 'or **browse** your documents',
      title: 'Drag your mandate here',
    },
  },
  fr: {
    checks: {
      company: 'Le mandat doit mentionner la société de votre client•e.',
      contractor:
        'Le mandat doit désigner votre client•e comme le **contracteur**.',
      date: 'Le mandat doit dater de **moins de 3 mois**.',
      mandatee:
        'Le mandat doit vous désigner ou votre entreprise comme le•la **mandataire**.',
      power:
        'Le mandat doit **obligatoirement** stipuler que vous avez le pouvoir pour **initier le dépôt de capital** et **ouvrir un compte bancaire**.',
      signature: 'Le mandat doit être signé **par votre client•e**.',
    },
    template: 'Télécharger notre modèle de mandat',
    upload: {
      description: 'ou **parcourez** vos documents',
      title: 'Faites glisser ici votre mandat',
    },
  },
} as const);
